function setTableScrolling() {
    // Find all bracket-scoring-table elements and check if any table inside needs scrolling
    document.querySelectorAll('.bracket-scoring-table').forEach(function(scoringTable) {
        let needsScroll = false;

        // Check all table-responsive elements within this scoring table
        scoringTable.querySelectorAll('.table-responsive').forEach(function(t) {
            let tableWidth = t.offsetWidth;
            let table = t.querySelector('table');

            if (table && table.offsetWidth > tableWidth) {
                t.style.overflowX = "scroll";
                needsScroll = true;
            } else {
                t.style.overflowX = "hidden";
            }
        });

        // Find the swiper that's a child of this scoring table
        let swiper = scoringTable.querySelector('.swiper');
        if (swiper) {
            swiper.style.display = needsScroll ? "block" : "none";
        }
    });
}

// Make function globally available for brackets.js to call
window.setTableScrolling = setTableScrolling;

document.addEventListener('DOMContentLoaded', function() {
    setTableScrolling();

    // Also observe bracket expansion to recalculate table scrolling
    // Using MutationObserver to watch for data-collapsed attribute changes
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-collapsed') {
                const bracket = mutation.target;
                if (bracket.getAttribute('data-collapsed') === 'false') {
                    // Bracket was expanded, recalculate after a short delay for CSS transitions
                    setTimeout(setTableScrolling, 50);
                }
            }
        });
    });

    // Observe all conference brackets for attribute changes
    document.querySelectorAll('.conference-bracket').forEach(function(bracket) {
        observer.observe(bracket, { attributes: true });
    });
});

window.addEventListener('resize', setTableScrolling);
